import { css } from 'styled-components';

export const sizes = {
  desktop: 1280,
  tabletL: 1024,
  tabletP: 768,
};

export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label] / 16}em) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});

export default media;
